import React from "react";
import { Helmet } from "react-helmet-async";

const Metatag = ({ title, description,link}) => {
  const canonicalLink = link ? `https://megavoltdxb.com/${link}` : "https://megavoltdxb.com/";
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalLink} />
    </Helmet>
  );
};

export default Metatag;